<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-09-01 14:05:48
 * @LastEditors: geory
 * @LastEditTime: 2026-03-03 14:20:26
-->
<template>
  <div class="editSucaiCover">
    <div class="editSucaiMain">
      <div class="editSucaiMainT">
        <div class="editSucaiMainTL">复用到</div>
        <img
          class="editSucaiMainTR"
          src="https://imagessl.lingtuo.cn/A-1ed71af7_20260128110047.png"
          @click="close"
        />
      </div>
      <div class="editSucaiMainB">
        <div>
          <div class="formItem1">
            <el-checkbox
              class="formItem1L"
              v-model="remarkChecked"
              >复用备注</el-checkbox
            >
            <div
              class="formItem1R"
              @click="addRemark"
            >
              添加备注
            </div>
          </div>
          <div
            v-for="(item, idx) in remarkList"
            :key="idx"
            class="cell"
          >
            <el-input
              v-model="item.remark"
              placeholder="请输入备注"
              :style="{ width: '720px' }"
            />
            <img
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20260129153922.png"
              @click="removeRemark(idx)"
            />
          </div>
        </div>
        <div :style="{ marginTop: '20px' }">
          <div class="formItem1">
            <el-checkbox
              class="formItem1L"
              v-model="resourceChecked"
              >显示来源（仅自己可见）</el-checkbox
            >
          </div>
        </div>
        <div class="subTitle">选择团队</div>
        <!-- <div :style="{ maxHeight: '600px', overflow: 'scroll' }"> -->
        <div>
          <el-checkbox-group
            v-model="selectedTeamIds"
            class="formItem1L"
          >
            <div
              v-for="(team, idx) in teams"
              :key="team.teamNO"
              :label="team.teamNO"
              class="teamItemP"
            >
              <div class="teamItem">
                <div class="teamItemSub">
                  <el-checkbox
                    :label="team.teamNO"
                    @change="teamShowClick(idx, $event, true)"
                  ></el-checkbox>
                  <img
                    class="teamItemImg"
                    :src="team.domain + team.logo"
                  />
                  <div class="teamItemName">{{ team.teamName }}</div>
                </div>
                <img
                  class="teamShowIcon"
                  :style="{
                    transform: team.categoryTagAreaShow
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)',
                  }"
                  src="https://imagessl.lingtuo.cn/A-1ed71af7_20260129172017.png"
                  @click="teamShowClick(idx)"
                />
              </div>
              <div>
                <div
                  v-if="team.categoryTagAreaShow"
                  class="formItemRB"
                >
                  <!-- <div class="formItemRBItemTConfirm">确定</div> -->
                  <div class="formItemRBItem">
                    <div class="formItemRBItemT">
                      <div>选择分类</div>
                      <!-- <div
                        class="formItemRBItemTConfirm"
                        @click="confirmCategoryTagSelection"
                      >
                        确定
                      </div> -->
                    </div>
                    <div
                      v-if="team.categoryList.length"
                      class="formItemRBItemB"
                    >
                      <div
                        v-for="category in team.categoryList"
                        :key="category.labelid"
                        :class="
                          team.selCategoryList.some(
                            (selCategory) =>
                              selCategory.labelid === category.labelid,
                          )
                            ? 'formItemRBItemBItem formItemRBItemBItemSel'
                            : 'formItemRBItemBItem'
                        "
                        @click="selectCategory(idx, category)"
                      >
                        {{ category.labelName }}
                      </div>
                    </div>
                    <div
                      v-if="team.tagList.length"
                      class="formItemRBItemT"
                    >
                      选择标签
                    </div>
                    <div
                      v-if="team.tagList.length"
                      class="formItemRBItemB"
                      :style="{ 'border-bottom': 'none' }"
                    >
                      <div
                        v-for="tag in team.tagList"
                        :key="tag.tagid"
                        :class="
                          team.selTagList.some(
                            (selTag) => selTag.tagid === tag.tagid,
                          )
                            ? 'formItemRBItemBItem formItemRBItemBItemSel'
                            : 'formItemRBItemBItem'
                        "
                        @click="selectTag(idx, tag)"
                      >
                        {{ tag.tagName }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <div class="editSucaiMainBottomBar">
        <div></div>
        <div
          class="formItemRTL"
          @click="resuseSucai"
        >
          复用
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import { Dialog, Loading, Input, Checkbox, CheckboxGroup } from "element-ui";
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(Input);

export default {
  name: "EditSucai",
  data() {
    return {
      pageWidth:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      pageHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      remarkChecked: false,
      resourceChecked: false,
      sucaiData: {},
      remarkList: [],
      selectedTeams: [],
      currentTeam: {},
      teams: [],
      selectedTeamIds: [],
    };
  },
  computed: {},
  watch: {
    selectedTeamIds(newVal, oldVal) {
      if (newVal.length !== oldVal.length) {
        this.selectedTeams = this.teams.filter((i) =>
          newVal.includes(i.teamNO),
        );
      }
    },
  },
  components: {},
  methods: {
    //查询分类列表
    queryCategoryList() {
      return new Promise(async (resolve, reject) => {
        let params = {
          teamNo: this.currentTeam.teamNO,
        };
        let resp = await this.$http.queryCategoryList(params);
        if (resp.code == 200) {
          this.currentTeam.categoryList = [...resp.data.array];
        }

        await this.queryTagList();
        resolve();
      });
    },
    //查询标签列表
    queryTagList(categoryId) {
      return new Promise(async (resolve, reject) => {
        let params = {
          teamNo: this.currentTeam.teamNO,
        };
        if (categoryId) {
          params.labelId = categoryId;
        }
        let resp = await this.$http.queryTagList(params);
        if (resp.code == 200) {
          this.currentTeam.tagList = [...resp.data.array];
          if (!categoryId) {
            this.currentTeam.allTagList = resp.data.array;
          }
        }
        resolve();
      });
    },
    async teamShowClick(idx, isCheck, isCheckState) {
      if (isCheck && isCheckState) {
        this.selectedTeams.push(this.teams[idx]);
      } else if (isCheckState) {
        this.selectedTeams = this.selectedTeams.filter(
          (i) => i.teamNO !== this.teams[idx].teamNO,
        );
        team.selCategoryList = [];
        team.selTagList = [];
      }
      const team = this.teams[idx];
      this.currentTeam = team;
      if (!team.categoryList || team.categoryList.length === 0) {
        team.selCategoryList = [];
        team.selTagList = [];
        await this.queryCategoryList();
      }
      if (isCheckState) {
        team.categoryTagAreaShow = isCheck;
      } else {
        team.categoryTagAreaShow = !team.categoryTagAreaShow;
      }
      this.teams.splice(idx, 1, team);
    },
    setSucai(data) {
      this.sucaiData = data.sucai;
      this.teams = JSON.parse(JSON.stringify(data.teamList));
    },
    // 选择分类
    async selectCategory(idx, item) {
      const team = this.teams[idx];
      team.selTagList = [];

      if (
        team.selCategoryList.some(
          (selCategory) => selCategory.labelid === item.labelid,
        )
      ) {
        team.selCategoryList = team.selCategoryList.filter(
          (i) => i.labelid !== item.labelid,
        );
        if (!team.selCategoryList.length) {
          team.tagList = team.allTagList;
        }
      } else {
        team.selTagList = [];
        team.selCategoryList.push(item);
        // if (team.categoryList.length != 1) {
        //   team.selTagList = [];
        // } else {
        //   await this.queryTagList(item.labelid);
        //   team.tagList = this.currentTeam.tagList;
        // }
        await this.queryTagList(item.labelid);
        team.tagList = this.currentTeam.tagList;
      }
      //深度更新team的categoryList
      this.teams.splice(idx, 1, team);
    },
    // 选择标签
    selectTag(idx, item) {
      const team = this.teams[idx];
      if (team.selTagList.some((selTag) => selTag.tagid === item.tagid)) {
        team.selTagList = team.selTagList.filter((i) => i.tagid !== item.tagid);
      } else {
        team.selTagList.push(item);
      }
      if (team.selTagList.length > 1 && team.selCategoryList.length > 1) {
        team.selCategoryList = [];
      }
      //深度更新team的tagList
      this.teams.splice(idx, 1, team);
    },
    removeRemark(idx) {
      this.remarkList.splice(idx, 1);
    },
    addRemark() {
      this.remarkList.push({
        remark: "",
      });
    },
    close() {
      this.$emit("close");
    },
    async resuseSucai() {
      if (!this.selectedTeams.length) {
        this.$message({
          message: "请选择团队",
          type: "warning",
        });
        return;
      }

      let toTeamArray = this.selectedTeams.map((i) => {
        return {
          teamNO: i.teamNO,
          labelArray: JSON.stringify(i.selCategoryList),
          tagArray: JSON.stringify(i.selTagList),
        };
      });

      let params = {
        teamNo: this.sucaiData.teamNO,
        id: this.sucaiData.id,
        isShowSource: this.resourceChecked ? 1 : 0,
        isCopyRemark: this.remarkChecked ? 1 : 0,
        toTeamArray: JSON.stringify(toTeamArray),
      };
      if (this.remarkChecked) {
        params.remarkArray = JSON.stringify(
          this.remarkList.map((i) => i.remark),
        );
      } else {
        params.remarkArray = "[]";
      }

      console.log("reuse params", params);
      let resp = await this.$http.reuseSucai(params);
      if (resp.code == 200) {
        this.$message({
          message: "复用成功",
          type: "success",
        });
        this.close();
      }
    },
  },
  async created() {},
  mounted() {},
  activated() {},
  watch: {
    // 监听素材类型变化，清空已选择的文件
    sucaiType() {
      this.selectedFiles = [];
    },
  },
};
</script>

<style>
.el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__inner,
.el-checkbox__inner {
  width: 20px;
  height: 20px;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #fd365d;
  border-color: #fd365d;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fd365d;
}

.el-checkbox__inner::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 11px;
  left: 7px;
  position: absolute;
  top: 0px;
  transform: rotate(45deg) scaleY(0);
  width: 6px;
  transition: transform 0.15s ease-in 0.05s;
  transform-origin: center;
}

.teamItem .el-checkbox__label {
  color: #fd365d;
  display: none !important;
}
</style>

<style scoped>
.editSucaiCover {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.editSucaiMain {
  width: 880px;
  /* min-height: 790px; */
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 #e5e5e580;
  position: relative;
  /* max-height: 90%; */
  /* overflow: scroll; */
}

.editSucaiMainT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 81px;
  padding: 0 24px;
  border-bottom: 1px solid #e5e5e5;
}

.editSucaiMainTL {
  font-size: 24px;
  line-height: 28px;
  color: #000000;
}

.editSucaiMainTR {
  width: 20px;
  height: 20px;
  display: block;
  cursor: pointer;
}

.editSucaiMainB {
  padding: 24px;
  /* padding-bottom: 100px; */
  height: 628px;
  overflow: scroll;
  padding-bottom: 20px;
}

.formItem1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.formItem1L {
}

.formItem1R {
  width: 80px;
  height: 32px;
  background-color: #fb5d5c;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
}

.editSucaiMainBottomBar {
  width: calc(100% - 92px);
  display: flex;
  justify-content: flex-end;
  padding: 16px 46px;
  border-top: 1px solid #e5e5e5;
  /* position: absolute;
  bottom: 0;
  right: 0; */
}

.cell {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.cell img {
  width: 16px;
  height: 16px;
  margin-left: 16px;
}

.subTitle {
  font-size: 18px;
  font-weight: 500;
  color: #3c3c3c;
  margin-top: 24px;
  padding: 16px 0;
  border-bottom: 1px solid #e5e5e5;
}

.teamItemP {
  border-bottom: 1px solid #e5e5e5;
}

.teamItem {
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.teamItemSub {
  display: flex;
  align-items: center;
}

.teamItemImg {
  width: 40px;
  height: 40px;
  margin-right: 16px;
  margin-left: 24px;
}
.teamItemName {
  font-size: 18px;
  font-weight: 500;
  color: #3c3c3c;
}

.teamShowIcon {
  width: 14px;
  height: 14px;
}

.formItemRBItem {
  padding: 20px;
  padding-bottom: 0;
  margin-bottom: 20px;
  background-color: #fafafa;
}

.formItemRBItemT {
  font-size: 16px;
  color: #3c3c3c;
  display: flex;
  justify-content: space-between;
}

.formItemRBItemTConfirm {
  width: 64px;
  height: 32px;
  background-color: #fb5d5c;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  position: absolute;
  right: 20px;
  top: 75px;
}

.formItemRBItemB {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e5e5e5;
}

.formItemRBItemBItem {
  height: 20px;
  border: 1px solid #e5e5e5;
  border-radius: 24px;
  padding: 10px 21px;
  background-color: #fff;
  font-size: 14px;
  line-height: 20px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.formItemRBItemBItemSel {
  background: #ffecec;
  border: 1px solid #fb5d5c;
  border-radius: 24px;
  color: #fb5d5c;
}

.formItemRTL {
  font-size: 16px;
  color: #3c3c3c;
  width: 136px;
  height: 40px;
  background-color: #fb5d5c;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
</style>
